import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
} from '@mui/icons-material';
import type { EditVorlageDialogProps } from './types';
import { WORKFLOW_KATEGORIEN } from './utils';
import WorkflowStepEditor from './WorkflowStepEditor';

const EditVorlageDialog: React.FC<EditVorlageDialogProps> = ({
  open,
  onClose,
  formData,
  onFormChange,
  onAddStep,
  onRemoveStep,
  onStepChange,
  onUpdate,
  isUpdating,
  availableUsers,
  availableWebhooks,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <EditIcon color="primary" />
          Workflow-Vorlage bearbeiten
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Vorlagen-Name"
              value={formData.name}
              onChange={(e) => onFormChange({ ...formData, name: e.target.value })}
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth required>
              <InputLabel>Kategorie</InputLabel>
              <Select
                value={formData.kategorie}
                onChange={(e) => onFormChange({ ...formData, kategorie: e.target.value })}
                label="Kategorie"
              >
                {WORKFLOW_KATEGORIEN.map((kat) => (
                  <MenuItem key={kat} value={kat}>{kat}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={formData.istAktiv ? 'aktiv' : 'inaktiv'}
                onChange={(e) => onFormChange({ ...formData, istAktiv: e.target.value === 'aktiv' })}
                label="Status"
              >
                <MenuItem value="aktiv">Aktiv</MenuItem>
                <MenuItem value="inaktiv">Inaktiv</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={2}
              label="Beschreibung (optional)"
              value={formData.beschreibung}
              onChange={(e) => onFormChange({ ...formData, beschreibung: e.target.value })}
            />
          </Grid>
        </Grid>

        <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
          Workflow-Schritte mit Automatisierung
        </Typography>

        {formData.schritte.map((schritt, index) => (
          <WorkflowStepEditor
            key={index}
            schritt={schritt}
            index={index}
            canRemove={formData.schritte.length > 1}
            onRemove={onRemoveStep}
            onChange={onStepChange}
            showAutomation
            availableUsers={availableUsers}
            availableWebhooks={availableWebhooks}
          />
        ))}

        <Button startIcon={<AddIcon />} onClick={onAddStep} variant="outlined" fullWidth>
          Schritt hinzufügen
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button
          variant="contained"
          onClick={onUpdate}
          disabled={isUpdating}
          startIcon={isUpdating ? <CircularProgress size={16} /> : <EditIcon />}
        >
          {isUpdating ? 'Speichert...' : 'Änderungen speichern'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditVorlageDialog;
